<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Medicine

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">




                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Medicine</label>
                      </div>
                      <div class="col-md-4" *ngIf="Typeofscreen=='Scan' && TcModelName!=='Fet' ">
                        <CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode">
                        </CustomDataByRequestType>

                      </div>
                      <div class="col-md-4" *ngIf="Typeofscreen=='Pickup' && TcModelName!=='Fet' ">
                        <CustomDataByRequestType RequestedType="IvfPickupMeds" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode">
                        </CustomDataByRequestType>

                      </div>
                      <div class="col-md-4" *ngIf="Typeofscreen=='PregTr' && TcModelName!=='Fet' ">
                        <CustomDataByRequestType RequestedType="IvfPregnancyMeds" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode">
                        </CustomDataByRequestType>

                      </div>
                      <div class="col-md-4" *ngIf="Typeofscreen=='Et' && TcModelName!=='Fet' ">
                        <!--<label for="firstName" class="margin-bottom-0px margin-top-5px">ET</label>-->

                        <CustomDataByRequestType RequestedType="IvfEmbTransDayMeds" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode">
                        </CustomDataByRequestType>

                      </div>

                      <div class="col-md-4" *ngIf="(Typeofscreen=='Scan' && TcModelName =='Fet')">
                        <!--<label for="firstName" class="margin-bottom-0px margin-top-5px">ET</label>-->

                        <CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode">
                        </CustomDataByRequestType>

                      </div>
                      <div class="col-md-4" *ngIf="(Typeofscreen=='Et' && TcModelName =='Fet')">
                        <!--<label for="firstName" class="margin-bottom-0px margin-top-5px">ET</label>-->

                        <CustomDataByRequestType RequestedType="IvfEmbTransDayMeds" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleMedicineDataRequest.MedicineCode">
                        </CustomDataByRequestType>

                      </div>
                    </div>

                  </div>
                </div>
                
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Dosage Form</label>
                      </div>
                      <div class="col-md-4" *ngIf="TcModelName!=='Fet'">

                        <CodeTypeValue CodeType="IVFDF"
                                       id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                       name="CurrentSaveIvfCycleMedicineDataRequest.Form"></CodeTypeValue>
                        <!--<input type="text" class="form-control" placeholder="Test"
           id="CurrentSaveIvfCycleMedicineDataRequest.Form"
           [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
           name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
           maxlength="100" required>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
    <small class="form-text text-danger"
           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                             id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                             [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                             name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
    </CustomDataByRequestType>-->
                      </div>

                      <div class="col-md-4" *ngIf="TcModelName=='Fet'">

                        <CodeTypeValue CodeType="FETDF"
                                       id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                       name="CurrentSaveIvfCycleMedicineDataRequest.Form"></CodeTypeValue>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Purpose</label>
                      </div>
                      <div class="col-md-4" *ngIf="TcModelName!=='Fet'">

                        <CodeTypeValue CodeType="MDPUR" id="CurrentSaveIvfCycleMedicineDataRequest.Objective"
                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Objective" SelectedValue=""
                                       name="CurrentSaveIvfCycleMedicineDataRequest.Objective">

                        </CodeTypeValue>

                      </div>

                      <div class="col-md-4" *ngIf="TcModelName=='Fet'">

                        <CodeTypeValue CodeType="FETMD" id="CurrentSaveIvfCycleMedicineDataRequest.Objective"
                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Objective" SelectedValue=""
                                       name="CurrentSaveIvfCycleMedicineDataRequest.Objective">

                        </CodeTypeValue>

                      </div>

                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Dose</label>
                      </div>
                      <div class="col-md-4 padding-right-0px col-5">

                        <input type="text" class="form-control" placeholder="Dose"
                               id="CurrentSaveIvfCycleMedicineDataRequest.Dose"
                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Dose"
                               name="CurrentSaveIvfCycleMedicineDataRequest.Dose" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                               maxlength="50">
                        <small class="form-text text-danger"
                               *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>


                      </div>
                      <div class="col-md-4 padding-right-0px col-3">
                        <CodeTypeValue CodeType="MEDDS"
                                       id="CurrentSaveIvfCycleMedicineDataRequest.DurationType" placeholder="Units"
                                       [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.DurationType" SelectedValue=""
                                       name="CurrentSaveIvfCycleMedicineDataRequest.DurationType" required></CodeTypeValue>



                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-tg-auto ">
                        <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Date</label>
                      </div>


                      <div class="col-md-4 col-5">
                        <div class="date-form">
                          <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp" [(ngModel)]="StartDate" ngbDatepicker #ds="ngbDatepicker" #Date="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!Date.valid && (Date.dirty || Date.touched) && Date.errors.required)">(Field cannot be left blank)</small>

                          <a (click)="ds.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Instructions </label>
                      </div>
                      <div class="col-md-6 ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->

                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Instructions"
                                  name="CurrentSaveIvfCycleMedicineDataRequest.Instructions"
                                  [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Instructions" minlength="1" maxlength="100"
                                  #addconcerns_text="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                      </div>
                    </div>


                  </div>
                </div>






              </div>
            </div>




















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="Date.errors?.required" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
